/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { AtomoTab } from "../AtomoTab";
import "./style.css";

export const ComponenteTabsWeb = ({
  className,
  atomoTabFrameClassName,
  atomoTabDivClassName,
  atomoTabLine = "/img/line-49.svg",
  atomoTabFrameClassNameOverride,
  atomoTabText = "Log in",
  login = true,
  signup = false,
  atomoTabDivClassNameOverride,
}) => {
  return (
    <div className={`componente-tabs-web ${className}`}>
      <AtomoTab
        active={login}
        className="atomo-tab-instance"
        divClassName={atomoTabDivClassName}
        line={atomoTabLine}
        text="Log in"
      />
      <AtomoTab
        active={signup}
        className="atomo-tab-instance"
        divClassName={atomoTabDivClassNameOverride}
        text={atomoTabText}
      />
    </div>
  );
};

ComponenteTabsWeb.propTypes = {
  atomoTabLine: PropTypes.string,
  atomoTabText: PropTypes.string,
};
